<!-- Proforma Docs Release Modal -->
<div class="modal fade" id="kt_modal_proforma_docs_release" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h2 class="fw-bold mb-0">Document Release Information</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <form [formGroup]="docsReleaseForm" (ngSubmit)="onSubmit()">
          <!-- Same As Consignee Checkbox -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="sameAsConsignee"
                  formControlName="sameAsConsignee"
                  (change)="onSameAsConsigneeChange($event)">
                <label class="form-check-label fw-semibold" for="sameAsConsignee">
                  Same As Consignee
                </label>
              </div>
            </div>
          </div>

          <!-- Receiver Name -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Receiver Name</label>
              <input
                type="text"
                class="form-control"
                placeholder="RECEIVER NAME"
                formControlName="receiverName"
                [class.is-invalid]="isFieldInvalid('receiverName')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('receiverName')">
                Receiver name is required
              </div>
            </div>
          </div>

          <!-- Address -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Address</label>
              <textarea
                class="form-control"
                rows="3"
                placeholder="Enter address"
                formControlName="address"
                [class.is-invalid]="isFieldInvalid('address')"></textarea>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('address')">
                Address is required
              </div>
            </div>
          </div>

          <!-- Post/Zip Code -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold">Post/Zip Code</label>
              <input
                type="text"
                class="form-control"
                placeholder="POST/ZIP CODE"
                formControlName="postZipCode">
            </div>
          </div>

          <!-- Country -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Country</label>
              <select
                class="form-select"
                formControlName="country"
                [class.is-invalid]="isFieldInvalid('country')">
                <option value="">Select</option>
                <option *ngFor="let country of countries" [value]="country.code">
                  {{ country.name }}
                </option>
              </select>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('country')">
                Country is required
              </div>
            </div>
          </div>

          <!-- City -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">City</label>
              <input
                type="text"
                class="form-control"
                placeholder="CITY"
                formControlName="city"
                [class.is-invalid]="isFieldInvalid('city')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('city')">
                City is required
              </div>
            </div>
          </div>

          <!-- Contact Person -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Contact Person</label>
              <input
                type="text"
                class="form-control"
                placeholder="CONTACT PERSON"
                formControlName="contactPerson"
                [class.is-invalid]="isFieldInvalid('contactPerson')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('contactPerson')">
                Contact person is required
              </div>
            </div>
          </div>

          <!-- Phone No. -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Phone No.</label>
              <input
                type="text"
                class="form-control"
                placeholder="PHONE NO."
                formControlName="phoneNo"
                [class.is-invalid]="isFieldInvalid('phoneNo')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('phoneNo')">
                Phone number is required
              </div>
            </div>
          </div>

          <!-- Email -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Email</label>
              <input
                type="email"
                class="form-control"
                placeholder="email@example.com"
                formControlName="email"
                [class.is-invalid]="isFieldInvalid('email')">
              <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                <span *ngIf="docsReleaseForm.get('email')?.errors?.['required']">Email is required</span>
                <span *ngIf="docsReleaseForm.get('email')?.errors?.['email']">Please enter a valid email</span>
              </div>
            </div>
          </div>

          <!-- Remarks -->
          <div class="row mb-4">
            <div class="col-12">
              <label class="form-label fw-semibold required">Remarks</label>
              <textarea
                class="form-control"
                rows="3"
                placeholder="EG. Please Send Docs by DHL, 2 SMART KEY By FEDEX"
                formControlName="remarks"
                [class.is-invalid]="isFieldInvalid('remarks')"></textarea>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('remarks')">
                Remarks is required
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="row">
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-primary px-8">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
